"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processSize = processSize;
function processSize(size) {
  return !/^\d+$/.test(size) ? size : size + "px";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-monaco-editor/lib/utils/process-size.js
// module id = 573
// module chunks = 53